const DIACRITIC_RE = /[̀-ͯ]/g;

// Versión para mostrar: conserva ñ y vocales acentuadas (Núñez, Peña, Ibáñez).
// Limpia caracteres no alfabéticos, normaliza espacios y aplica capitalización tipo título.
export function normalizeName(str: string | null | undefined): string {
  if (!str) return '';
  return str
    .replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s-]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean)
    .map((w) => w.charAt(0).toLocaleUpperCase('es-ES') + w.slice(1).toLocaleLowerCase('es-ES'))
    .join(' ');
}

// Versión para emparejar: sin diacríticos ni ñ, lowercase. Mantiene match estable
// frente a datos antiguos guardados sin ñ/tildes.
export function normalizeNameForMatch(str: string | null | undefined): string {
  return stripDiacritics(normalizeName(str)).toLowerCase().replace(/\s+/g, ' ').trim();
}

export function stripDiacritics(str: string): string {
  return str.normalize('NFD').replace(DIACRITIC_RE, '');
}
